module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/system/approbation-group/approbation-group.scss
// module id = ./src/app/system/approbation-group/approbation-group.scss
// module chunks = main